import { VillageUIThemeProvider } from '@village/ui';
import { FC, PropsWithChildren } from 'react';

import { CustomGlobalStyles } from './global-styles';
import { villageMdTheme } from './theme';

const ThemeProvider: FC<PropsWithChildren> = ({ children }) => {
    return (
        <VillageUIThemeProvider theme={villageMdTheme}>
            <CustomGlobalStyles />
            {children}
        </VillageUIThemeProvider>
    );
};

export { ThemeProvider };
